import { render, staticRenderFns } from "./smd-aileron.vue?vue&type=template&id=f5995f8a&"
import script from "./smd-aileron.vue?vue&type=script&lang=js&"
export * from "./smd-aileron.vue?vue&type=script&lang=js&"
import style0 from "./smd-aileron.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports